module.exports = __webpack_public_path__ + "img/android.a2d1db8d.png";